export var IdAssetBundleWatertower;
(function (IdAssetBundleWatertower) {
    IdAssetBundleWatertower["Watertower_1"] = "Watertower_1";
    IdAssetBundleWatertower["Watertower_2"] = "Watertower_2";
    IdAssetBundleWatertower["Watertower_3"] = "Watertower_3";
    IdAssetBundleWatertower["Watertower_4"] = "Watertower_4";
    IdAssetBundleWatertower["Watertower_5"] = "Watertower_5";
})(IdAssetBundleWatertower || (IdAssetBundleWatertower = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleWatertower.ts
// module id = 2144
// module chunks = 3